import React, { useState, useEffect, useContext } from 'react';
import AulaUserContext, { aulaAuthHeaders, setAulaSession } from '../aulaUserContext';

const jsonHeaders = () => ({ 'Content-Type': 'application/json;charset=UTF-8', ...aulaAuthHeaders() });

const AulaPerfil = () => {
    const { aulaAuth, setAulaAuth } = useContext(AulaUserContext);
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [contrasenaActual, setContrasenaActual] = useState('');
    const [contrasenaNueva, setContrasenaNueva] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        fetch('/aula/auth/perfil', { headers: aulaAuthHeaders() })
            .then((res) => res.json())
            .then((data) => { setNombre(data.nombre); setEmail(data.email); });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(''); setMensaje('');

        fetch('/aula/auth/perfil', {
            method: 'PUT',
            headers: jsonHeaders(),
            body: JSON.stringify({ nombre, contrasenaActual, contrasenaNueva: contrasenaNueva || null })
        }).then(async (res) => {
            if (res.status === 200) {
                setMensaje('Datos actualizados.');
                setContrasenaActual(''); setContrasenaNueva('');
                setAulaAuth({ ...aulaAuth, nombre });
                setAulaSession({ token: aulaAuth.token, nombre, rol: aulaAuth.rol });
            } else {
                setError('No se pudo actualizar (revisá tu contraseña actual).');
            }
        });
    };

    return (
        <div className="container my-4">
            <h3 className="title">Mi perfil</h3>
            <div className="row">
                <div className="col-md-6">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Nombre</label>
                            <input className="form-control" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input className="form-control" value={email} disabled />
                        </div>
                        <hr />
                        <p>Para cambiar tu contraseña, completá los dos campos siguientes:</p>
                        <div className="form-group">
                            <label>Contraseña actual</label>
                            <input type="password" className="form-control" value={contrasenaActual}
                                onChange={(e) => setContrasenaActual(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Contraseña nueva</label>
                            <input type="password" className="form-control" value={contrasenaNueva}
                                onChange={(e) => setContrasenaNueva(e.target.value)} minLength={6} />
                        </div>
                        <button type="submit" className="btn aula-btn-primary">Guardar cambios</button>
                        {mensaje && <span className="d-block text-success mt-2">{mensaje}</span>}
                        {error && <span className="d-block text-danger mt-2">{error}</span>}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AulaPerfil;
